module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('pickup-locations')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /source/~/vue-loader/lib/template-compiler.js?{"id":"data-v-9af8eeca"}!/source/~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 124
// module chunks = 0